module.exports = __webpack_public_path__ + "img/icon-type-video.d1995e8e.svg";